(function($) {

    siteHeader = $('#siteHeader');
    siteMain = $('#siteMain');
    siteHeaderHeight = siteHeader.outerHeight();

    // Toggle collapse on submenu
    $('#navbarToggle').on('click', function() {
        var primaryNavigation = $('#primaryNavigation');
        $this = $(this);

        // Dropdown toggle setup
        if(primaryNavigation.hasClass('is-expanded')) {
            primaryNavigation.removeClass('is-expanded');
            $('body').removeClass('no-scroll');
            $this.addClass('collapsed');
            $this.attr('aria-expanded', 'false');

        } else {
            primaryNavigation.addClass('is-expanded');
            $('body').addClass('no-scroll');
            $this.removeClass('collapsed');
            $this.attr('aria-expanded', 'true');
        }
    });

    if($(window).width() < 1201 && $('.site-alert').length) {
        $('#primaryNavigation').css('top', $('.site-alert').outerHeight(), 'important');
        $('.sm-mobile-updt .dropdown-menu-large').css('top', $('.site-alert').outerHeight(), 'important');
    } else {
        $('#primaryNavigation').css('top', 0);
        $('.sm-mobile-updt .dropdown-menu-large').css('top', 0);
    }

    $('.request-drivers-dropdown-toggle').on('click', function() {
        $('.request-drivers-dropdown').slideToggle();
    });

}(jQuery));
